import styled, { keyframes } from 'styled-components';
const MODAL_SIZES = {
    small: '400px',
    medium: '600px',
    large: '800px',
};
const withSizes = (size) => {
    return MODAL_SIZES[size];
};
export const ModalWrapper = styled.div `
  align-items: center;
  background-color: #00000055;
  border: 0;
  display: flex;
  height: 100%;
  justify-content: center;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
  width: 100%;
  z-index: var(--z-index-900-modal, 900);
  transition: opacity ease 300ms;
  opacity: 0;
  visibility: hidden;
  will-change: transform;
  pointer-events: none;

  &.show {
    opacity: 1;
    visibility: visible;
    pointer-events: auto;
  }

  @media (max-width: 481px) {
    align-items: flex-end;
  }
`;
const translateY = keyframes `
  from {
    transform: translateY(0%);
  }

  to {
    transform: translateY(100%);
  }
`;
export const Modal = styled.div `
  background-color: white;
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  width: ${({ size }) => withSizes(size)};
  max-width: ${({ maxWidth }) => maxWidth};
  max-height: ${({ maxHeight }) => maxHeight};
  min-height: 200px;
  padding: 24px 32px;
  position: relative;
  transition: opacity ease 300ms;
  opacity: 0;
  transition: all ease 0.3s;
  transform: translateY(10%) scale(0.9);

  &.show {
    opacity: 1;
    transform: scale(1);
  }

  @media (max-width: 481px) {
    border-bottom-left-radius: 0px;
    border-bottom-right-radius: 0px;
    transform: translateY(100%) scale(0.9);
    /* animation: ${translateY} 600ms linear reverse; */

    &.show {
      transform: translateY(0);
    }
  }
`;
export const ButtonWrapper = styled.button `
  align-items: center;
  background-color: #00000000;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  display: inline-flex;
  justify-content: center;
  outline: none;
  padding: 5px;

  :hover {
    background-color: #f6f6f6;
  }

  :focus {
    outline: var(--border-width-thin) solid var(--color-neutral-130);
    border-radius: var(--border-radius-pill);
  }
`;
export const IconContainer = styled.div `
  display: flex;
  justify-content: flex-end;
`;
export const FooterContainer = styled.div `
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  ::-webkit-scrollbar {
    width: 10px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 15px;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: #aaa;
    border-radius: 15px;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: #888;
  }
`;
